let _beforeUnloadHandler = null;

export const clearSessionStorage = () => {
  if (_beforeUnloadHandler) {
    window.removeEventListener("beforeunload", _beforeUnloadHandler);
  }

  _beforeUnloadHandler = () => {
    // Preserve auth keys across the clear
    const user = sessionStorage.getItem("user-s");
    const userId = user ? JSON.parse(user)?.id : null;
    const adminBusiness = userId
      ? sessionStorage.getItem(`admin-${userId}`)
      : null;

    sessionStorage.clear();

    if (user) sessionStorage.setItem("user-s", user);
    if (adminBusiness) sessionStorage.setItem(`admin-${userId}`, adminBusiness);
  };

  window.addEventListener("beforeunload", _beforeUnloadHandler);
};
